export default __webpack_public_path__ + "static/media/Agarose_Gel.925ce025.svg";